import React from 'react';

import StatusCell from '../../../components/Badge/StatusCell';
import Table from '../../../components/Table/Table';

const PartnersCompanyList = () => {
  // const navigate = useNavigate();

  return (
    <Table
      // border
      tableTitle='PARTNER LIST'
      tableFilterBoxFeatures={{
        showSearchBox: true,
        searchBoxPlaceholder: 'Search Partner Name',
      }}
      tableHeader={{
        'Partner Name': 'companyName',
        'Partner Industry': 'companyIndustry',
        'No. of Drivers': 'noOfDrivers',
        'Performance Status': 'performanceStatus',
      }}
      tableDataSourceUrl='ba/v1/company/performance-status'
      cellsCustomComp={{
        performanceStatus: <StatusCell statusKey='performanceStatus' hasDot />,
      }}
      // moreOptionsComponents={[
      //   <ActionRow
      //     key='View performance'
      //     label='View performance'
      //     width='257px'
      //     icon={<AnalyticsIcon />}
      //     actionFn={async (data: any) =>
      //       navigate(`/${PERFORMANCE_MONITORING_VIEW_PERFORMANCE}`)
      //     }
      //   />,
      // ]}
      // mobileCellComp={<UserProfileManagementCell />}
      // showPaginationControl={false}
    />
  );
};
export default PartnersCompanyList;
